import APIRequest from '../api/APIRequest';

const apiRequest = new APIRequest();
const API_BASE = '/admin'; // Changed from '/api/admin'

export const designationService = {
  // Get all designations
  getAllDesignations: async (token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations`,
        'GET',
        null,
        token
      );
      return response;
    } catch (error) {
      console.error('Error fetching designations:', error);
      throw error;
    }
  },

  // Add new designation
  addDesignation: async (name, fieldType, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations`,
        'POST',
        { name, fieldType },
        token
      );
      return response;
    } catch (error) {
      console.error('Error adding designation:', error);
      throw error;
    }
  },

  // Delete designation
  deleteDesignation: async (id, token) => {
    try {
      const response = await apiRequest.request(
        `${API_BASE}/designations/${id}`,
        'DELETE',
        null,
        token
      );
      return response;
    } catch (error) {
      console.error('Error deleting designation:', error);
      throw error;
    }
  },
};
